import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Partners() {
  return (
    <PageLayout
      title="Ecosystem Partners"
      subtitle="Join the Wheelcall LLC revenue share ecosystem and build atop the Paygent infrastructure."
      badge="REVENUE SHARE"
      imageSrc="/products/art_partners_1776905226085.png"
    >
      <div className="bg-white rounded-3xl border border-gray-100 p-10 md:p-16 mt-16 text-center">
        <div className="w-20 h-20 mx-auto bg-blue-50 text-blue-600 rounded-full flex items-center justify-center mb-6">
          <i className="ri-hand-heart-line text-4xl"></i>
        </div>
        <h2 className="text-3xl font-extrabold text-gray-900 mb-6">Build With Us</h2>
        <p className="text-gray-600 text-lg max-w-2xl mx-auto mb-10">
          We share the interchange spread with our verified integration partners. Whether you're building specialized ERP software, a ticketing platform, or a restaurant POS, integrating Paygent's API allows you to monetize your customers' payment volume.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto text-left">
          <div className="p-6 bg-gray-50 rounded-xl border border-gray-100">
            <h4 className="font-bold text-gray-900 mb-2">1. Integrate</h4>
            <p className="text-sm text-gray-500">Embed Pathfinder APIs directly into your product flow.</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-xl border border-gray-100">
            <h4 className="font-bold text-gray-900 mb-2">2. Board Users</h4>
            <p className="text-sm text-gray-500">Your users get an instant merchant account under your portfolio.</p>
          </div>
          <div className="p-6 bg-gray-50 rounded-xl border border-gray-100">
            <h4 className="font-bold text-gray-900 mb-2">3. Earn Spread</h4>
            <p className="text-sm text-gray-500">Receive monthly residuals on every transaction they process.</p>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
